(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["group-tabs"] && !Shopify.designMode) return;
  try {
    class GroupTabs extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready === 'true') return;
      this.dataset.ready = 'true';

      this.buttons = [...this.querySelectorAll('[data-group-tab]')];
      this.addEventListener('click', this.onClick);
      this.addEventListener('keydown', this.onKeydown);
    }

    select(id) {
      document.body.dataset.homeGroup = id;
      this.buttons.forEach((button) => {
        const on = button.getAttribute('data-group-tab') === id;
        button.classList.toggle('is-active', on);
        button.setAttribute('aria-checked', on ? 'true' : 'false');
      });
    }

    idForGroupLink(link) {
      let url;
      try {
        url = new URL(link.getAttribute('href'), window.location.href);
      } catch (error) {
        return null;
      }
      if (url.origin !== window.location.origin || url.pathname !== window.location.pathname) return null;
      const match = url.hash.match(/^#group-(.+)$/i);
      if (!match) return null;
      const slug = decodeURIComponent(match[1]).replace(/\+/g, ' ').toLowerCase();
      const button = this.buttons.find((item) => GroupTabs.slug(item.getAttribute('data-group-tab')) === slug);
      return button ? button.getAttribute('data-group-tab') : null;
    }

    static slug(value) {
      return value.trim().toLowerCase().replace(/\s+/g, '-');
    }

    onClick = (event) => {
      const button = event.target.closest('[data-group-tab]');
      if (!button || !this.contains(button)) return;
      this.select(button.getAttribute('data-group-tab'));
    };

    onKeydown = (event) => {
      if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
      const index = this.buttons.indexOf(document.activeElement);
      if (index === -1) return;
      event.preventDefault();
      const next = event.key === 'ArrowRight'
        ? (index + 1) % this.buttons.length
        : (index - 1 + this.buttons.length) % this.buttons.length;
      this.buttons[next].focus();
      this.select(this.buttons[next].getAttribute('data-group-tab'));
    };
  }

  if (!customElements.get('group-tabs')) {
    customElements.define('group-tabs', GroupTabs);
  }

  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[href*="#group-"]');
    if (!link) return;
    const tabs = document.querySelector('group-tabs');
    if (!tabs) return;
    const id = tabs.idForGroupLink(link);
    if (!id) return;
    event.preventDefault();
    tabs.select(id);
  });
  } catch(e) { console.error(e); }
})();

})();
